import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import type { Role } from "../api/types";
import { useAuth } from "../context/AuthContext";
import { FullScreenLoader } from "./ui";

export function RequireRole({ role, children }: { role: Role; children: ReactNode }) {
  const { loading, session } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  const loginPath = role === "ADMIN" ? "/admin/login" : "/login";
  if (!session?.authenticated) return <Navigate to={loginPath} replace state={{ from: location.pathname }} />;
  if (session.role !== role) {
    return <Navigate to={session.role === "ADMIN" ? "/admin" : "/me"} replace />;
  }
  return <>{children}</>;
}
